import * as React from 'react';

import { ESalesType, ISalesLink } from '../../types/offersData';
import { SalesLink } from './components/SalesLink';

import * as styles from './SalesLinks.css';
import { AdditionalLink } from './components/AdditionalLink';
interface ISalesLinksProps {
  links: ISalesLink[];
  onLinkClick(type: ESalesType): void;
}

const MAIN_SALES_TYPES = [ESalesType.UpcomingSale, ESalesType.SalesStart, ESalesType.SalesLeader];

export function SalesLinks({ links, onLinkClick }: ISalesLinksProps) {
  const mainLinks = React.useMemo(() => links.filter(link => MAIN_SALES_TYPES.includes(link.salesType)), [links]);
  const additionalLinks = React.useMemo(
    () => links.filter(link => !MAIN_SALES_TYPES.includes(link.salesType)),
    [links],
  );

  return (
    <div className={styles['container']}>
      <div className={styles['links']}>
        {mainLinks.length > 0 && <SalesLink title="Все" />}
        {mainLinks.map((link, index) => (
          <SalesLink key={index} onClick={onLinkClick} title={link.title} url={link.url} type={link.salesType} />
        ))}
      </div>
      {additionalLinks.map((link, index) => (
        <AdditionalLink
          key={index}
          onClick={onLinkClick}
          title={link.title}
          url={link.url}
          type={link.salesType}
          isNew={link.salesType === ESalesType.ConsultantPage}
        />
      ))}
    </div>
  );
}
